import * as Sentry from '@sentry/browser';

export default () =>
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_URL,
    // NextivaEnv is set in env.js file, which is deployed to different environments by deploy jobs.
    environment: window.NextivaEnv ? window.NextivaEnv : 'local',
    release: process.env.REACT_APP_RELEASE,
  });
